module.exports = __webpack_public_path__ + "img/Invasion-BRCA_10X_IDC.f25f0af7.png";